// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export const formatClassName = (name: string): string => {
  let result = '';
  if (name !== null && name !== undefined) {
    result = name.replace(/\s+/g, '-').toLowerCase();
  }

  return result;
};
